import { isDevOrPreviewSite } from '../../utils/general'
import {
  F_API_KEY,
  F_CUSTOM_DOMAIN,
  F_EDIT_MODE,
  F_PWD_PROTECTION,
  F_MINIMALIST_MODE,
  F_PRESENTATION_MODE,
  F_TRACKED_LINKS,
  F_PDF_PAGE_ANALYTICS,
  F_DOWNLOAD_ANALYTICS,
  F_PDF_TO_WEBSITE
} from './constants'

const isDev = isDevOrPreviewSite()

const SOLO_PLAN = {
  id: isDev ? 'prod_HXjPwsEONzD5oI' : 'prod_HXjN9aML8fXChn',
  label: 'Solo',
  prices: {
    yearly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 156,
          priceId: isDev ? 'price_1KfVJZKnX1nnNv6IkJoWrMxg' : 'price_1KfV3kKnX1nnNv6IwPx129d6'
        },
        eur: {
          symbol: '€',
          value: 156,
          priceId: isDev ? 'price_1PVcXOKnX1nnNv6I7wLpEKD6' : 'price_1PVcupKnX1nnNv6InHV1dGMn'
        },
        gbp: {
          symbol: '£',
          value: 120,
          priceId: isDev ? 'price_1PVccTKnX1nnNv6Iz5pLqDm2' : 'price_1PVcwSKnX1nnNv6IYbsyX6Il'
        },
        inr: {
          symbol: '₹',
          value: 6600,
          priceId: isDev ? 'price_1PVcdKKnX1nnNv6I60V800oi' : 'price_1Q7FJaKnX1nnNv6IeLyQRISf'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25g6e9ce6214z53rdfrv5y' : 'pri_01kerz4f660prdgr6n53p7x56b' },
      payPro: { priceId: isDev ? 103223 : 103224 }
    },
    monthly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 18,
          priceId: isDev ? 'price_1KfVLOKnX1nnNv6IRf8vpcvK' : 'price_1KfV2zKnX1nnNv6ICHQPi5Qp'
        },
        eur: {
          symbol: '€',
          value: 18,
          priceId: isDev ? 'price_1PVcf2KnX1nnNv6IOrWN6ltG' : 'price_1PlVNlKnX1nnNv6IbmYRSOPC'
        },
        gbp: {
          symbol: '£',
          value: 14,
          priceId: isDev ? 'price_1PVce4KnX1nnNv6II4M7tgTN' : 'price_1PlVOzKnX1nnNv6IzmBdZEi9'
        },
        inr: {
          symbol: '₹',
          value: 895,
          priceId: isDev ? 'price_1PVcfhKnX1nnNv6IGElnCqKd' : 'price_1Qiqq3KnX1nnNv6IQSw7BPry'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25egeyxgg1btw22ke9t34z' : 'pri_01kerz3qwcvr6k8tapcd3bxsj6' },
      payPro: { priceId: isDev ? 103221 : 103222 }
    }
  },
  fileSizeLimit: 75,
  customDomainsLimit: 5,
  projectLimit: 5,
  visitorLimit: 100000,
  bandwidthLimit: 50,
  features: {
    [F_CUSTOM_DOMAIN]: true,
    [F_PWD_PROTECTION]: true,
    [F_EDIT_MODE]: true,
    [F_API_KEY]: true,
    [F_PRESENTATION_MODE]: true,
    [F_MINIMALIST_MODE]: true,
    [F_TRACKED_LINKS]: true,
    [F_PDF_PAGE_ANALYTICS]: true,
    [F_DOWNLOAD_ANALYTICS]: true,
    [F_PDF_TO_WEBSITE]: true
  }
}

export default SOLO_PLAN
